export default __webpack_public_path__ + "static/media/036-trash can.c94c0b85.svg";